/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {SwitchButtonConfiguration} from '../../../shared/switch-button/configuration/switch-button.configuration';

export const bundlesAutoCloseConfiguration: {
    buttonConfiguration: SwitchButtonConfiguration;
    tooltipTitle: string;
    baseTooltipText: string;
} = {
    buttonConfiguration: {
        label: 'Automatic bundles closure',
        labelOnRight: true,
        spaceInBetween: 2
    },
    tooltipTitle: 'AUTOMATIC BUNDLES CLOSURE',
    baseTooltipText: 'Once active, at the end of the period all bundles will be automatically closed. ' +
            'If inactive, the bundles must be manually closed by a bundle manager user.'

};

